import {defineStore} from 'pinia'

const name = 'appEnv'

export const useAppEnvStore = defineStore(name,{

  id: name,

  state: () => ({
      env: {},
      current: 0,
      // Statut du chargement de l'env depuis le backend (GET /appEnv/load) :
      // 'idle' (jamais tenté) | 'loading' | 'loaded' (succès) | 'error' (backend
      // injoignable). Permet à noLanding.vue de distinguer « backend down »
      // (→ Maintenance) d'une landing réellement non configurée (→ message admin).
      status: 'idle',
    }
  ),

  actions: {

    load(payload) {
      this.env = payload;
    },

    setStatus(status) {
      this.status = status;
    },

  },
  getters: {
    /**
     * Get environment variable
     * Priority: DB (state.env) > Build config (window.environment)
     * This allows APP_CODE from database to override build-time config
     */
    getEnv: (state) => (name) => {
      return state.env[name] || window?.environment?.[name];
    },
  }

})
